import { create } from 'zustand'

const initialState = {
  openComment: null,
  commentsMap: {},
  commentsColorMap: {},
}

const useAuthoringCommentsStore = create((set) => ({
  ...initialState,
  setOpenComment: (openComment) => set({ openComment }),
  setCommentsMap: (commentsMap) => set({ commentsMap }),
  resetAuthoringCommentsStore: () => set(initialState),
  setCommentColorMap: (commentsColorMap) => set({ commentsColorMap }),
}))

export default useAuthoringCommentsStore;